import React from 'react';
import { useTranslation } from 'react-i18next';

import { DatePicker, IDatePickerProps } from '@fluentui/react';
import { CallableFn } from './CustomInput';
import CustomInputIfc from './CustomInputIfc';
import { DateTime } from 'luxon';
import { getLocalizedStrings } from '../../LocalizedStringsForDatePicker';
import { DateFormatter } from '../../DateFormatter';

interface IDatePickerInput {
  input: CustomInputIfc;
  onChangeExtended?: (input: CustomInputIfc) => void;
  onBlur: (input: CustomInputIfc) => void;
  label: string;
  useTime?: boolean;
  propsInput?: IDatePickerProps;
}

export const DatePickerInput = (props: IDatePickerInput) => {
  const { t } = useTranslation();

  const [updateFlag, setUpdateFlag] = React.useState(false);

  const onFormatDate = (date?: Date): string => {
    if (!props.useTime) {
      return DateFormatter.formatDate(date);
    } else {
      // todo
    }
    // return !date ? '' : date.getDate() + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear() % 100);
    return date ? DateTime.fromJSDate(date).toFormat('yyyy/LL/dd') : '';
  };

  const updateViewAfterDoing = (anAction: CallableFn) => {
    setUpdateFlag((u) => {
      anAction();
      return !u;
    });
  };

  const onChangeCustomInput = (input: CustomInputIfc, value: Date) => {
    updateViewAfterDoing(() => {
      props.input.setValue(value);
      // props.input.setValue(DateTime.fromJSDate(value));
      onBlurCustomInput();
    });
  };

  const onBlurCustomInput = () => {
    updateViewAfterDoing(() => {
      props.input.onBlur();
      props.onBlur(props.input);
    });
  };

  React.useEffect(() => {
    // console.log(props.input);
  }, [props.input]);

  return (
    <>
      {/* {console.log(props.input.getValue())} */}
      <DatePicker
        strings={getLocalizedStrings()}
        label={t(props.label)}
        formatDate={onFormatDate}
        value={props.input.getValue()} //.toJSDate()}
        onSelectDate={(date) => {
          if (date) {
            onChangeCustomInput(props.input, date);
          }
        }}
        {...props.propsInput}
      />
    </>
  );
};
